/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { StyleSheet, Text, Pressable } from 'react-native';
import { Icon as RNVIcon } from 'renative';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';
import { formatDay, formatMonth } from 'Utils';
import pubSub from '../../../../pubSub';
import { ACTION } from '../../../../pubSub/actions';

class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayDatePicker: false,
            selectedDate: new Date()
        };
        this.subscriberId = 'date-pick-toggler-component';
        pubSub.subscribe(ACTION.ON_EPG_DATE_SELECT, this.changeDatePickerState, this.subscriberId);
    }

    changeDatePickerState = ({ date, toggle = true }) => {
        const { displayDatePicker, selectedDate } = this.state;
        this.setState({
            displayDatePicker: toggle ? !displayDatePicker : displayDatePicker,
            selectedDate: date || selectedDate
        });
    };

    handlePress = () => {
        const { displayDatePicker } = this.state;

        pubSub.dispatch(ACTION.ON_EPG_DATE_SELECT, {});
        this.setState({ displayDatePicker: !displayDatePicker });
    };

    componentWillUnmount() {
        pubSub.unsubscribe(this.subscriberId);
    }

    dayText = (selectedDate) =>
        Device.isTablet
            ? `${formatDay(selectedDate.getDay())}, ${selectedDate.getDate()}. ${formatMonth(
                  selectedDate.getMonth(),
                  3
              )}`
            : `${formatDay(selectedDate.getDay(), 2)}., ${selectedDate.getDate()}.${
                  selectedDate.getMonth() + 1
              }.`;

    render() {
        const { displayDatePicker, selectedDate } = this.state;
        return (
            <Pressable
                testID="date_picker"
                // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
                // eslint-disable-next-line no-use-before-define
                style={styles.toggler}
                onPress={this.handlePress}
            >
                {/* TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659 */}
                {/* eslint-disable-next-line no-use-before-define */}
                <Text
                    style={[styles.togglerText, { color: displayDatePicker ? '#4b4b4b' : '#fff' }]}
                >
                    {this.dayText(selectedDate)}
                </Text>
                <RNVIcon
                    iconFont="fontAwesome"
                    iconName={displayDatePicker ? 'caret-up' : 'caret-down'}
                    iconColor={displayDatePicker ? '#4b4b4b' : '#fff'}
                    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
                    // eslint-disable-next-line no-use-before-define
                    style={styles.icon}
                    onPress={this.handlePress}
                />
            </Pressable>
        );
    }
}

const styles = StyleSheet.create({
    toggler: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '80%',
        backgroundColor: '#000',
        marginLeft:20
    },
    togglerText: {
        fontSize: 22,
        marginLeft: 20,
        color: Theme.primaryTextColor,
        fontFamily: Theme.regularFont,
        textAlign: 'center',
        letterSpacing: 0.7
    },
    icon: {
        width: 17,
        marginLeft: 10
    }
});

export default DatePicker;
